// Unsaved-draft autosave for long field inputs (New Log, 360 update). Local only,
// keyed per project, expires after 24 h, cleared on save. (Round 13)
const EXPIRY_MS = 24 * 3600 * 1000;

export function saveDraft(key, text) {
  try { localStorage.setItem(key, JSON.stringify({ text, ts: Date.now() })); } catch { /* ignore */ }
}

export function loadDraft(key) {
  try {
    const d = JSON.parse(localStorage.getItem(key) || "null");
    if (!d || !d.text || !d.text.trim() || Date.now() - d.ts > EXPIRY_MS) return null;
    return d;
  } catch { return null; }
}

export function clearDraft(key) {
  try { localStorage.removeItem(key); } catch { /* ignore */ }
}
